import axios from 'axios';
import { setEmptyToken, setLoggedIn } from '../redux/slices/auth/activeAccount';
import { setErrorMsg } from '../redux/slices/errorHandling/errorHandling';
import store from '../redux/store';

let token = 0;

// const BASE_URL = 'https://e-govuat-srv.cdcaccess.com.pk/v1';
// const BASE_URL = 'https://ego-be.mediaboundary.com/v1/';
const BASE_URL = `${process.env.REACT_APP_SERVER_BASE_URL}`;
// const BASE_URL = "http://localhost:8443/v1/";
const Api = axios.create({
	baseURL: BASE_URL,
	// mode: 'cors',
	headers: {
		'Content-Type': 'application/json',
	},
});

export const axiosPrivate = axios.create({
	baseURL: BASE_URL,
	headers: { 'Content-Type': 'application/json' },
	withCredentials: true,
});

Api.interceptors.request.use(
	async (request) => {
		const account = await store.getState().activeAccount;
		const xtUserToken = request.headers['xt-user-token'];
		const xtClientToken = request.headers['xt-client-token'];
		const isLoggedIn = account?.isLoggedIn;
		const token = account?.token;
		if (token && isLoggedIn) {
			if (xtUserToken === null) {
				request.headers["xt-user-token"] = `${token}`;
			}
			if (xtClientToken === null) {
				request.headers["xt-client-token"] = `${token}`;
			}
		}
		else {
			request.headers["xt-client-token"] = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnQiOiIxIiwiY2xpZW50VG9rZW5JZCI6IjJiZDkzOWRiLTFiNTQtNGU3OS1iMWNlLTdiNzE4M2NhMTUwMSIsInV1aWQiOiI5MTYyZDYyMC00NTVlLTQwMDYtOGUzOS1jYTZmYWUxMmMwNDAiLCJ0aW1lIjoxNzA5NjQ2NjAxNzg0LCJpYXQiOjE3MDk2NDY2MDF9.UGvEVJJ28dezLuJHlwTJL-pa2ja-rHHw1pYfnS9V674`;
		}

		return request;
	},
	(error) => Promise.reject(error),
);

Api.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (axios.isCancel(error)) {
			return new Promise(() => { });
		}

		if (error?.response?.status === 401) {
			store.dispatch(setEmptyToken());
			store.dispatch(setLoggedIn(false));
			localStorage.clear();
		}
		return Promise.reject(error);
	},
);

Api.interceptors.response.use(
	(response) => response,
	async (error) => {
		// const originalRequest = error.config;
		// console.log(
		// 	'ERROR CODE',
		// 	error?.response?.status,
		// 	'ERROR MSG',
		// 	error?.response?.data,
		// 	'error***',
		// 	error,
		// );

		if (error?.response?.status === 400) {
			// store.dispatch(setErrorMsg(error?.response?.data?.msg));
			// console.log(error);
		}

		if (error?.response?.status === 401) {
			store.dispatch(setErrorMsg(error?.response?.data?.message));
			// console.log(error?.response?.data?.message);
		}

		if (error?.response?.status === 404) {
			// store.dispatch(setErrorMsg('Not Found'));
			// console.log(error);
		}

		// if (error.message == 'Network Error') {
		//   Toast.show('Please connect your device on network', Toast.LONG);
		// } else if (error?.response?.status == 500) {
		//   Toast.show('Server Error', Toast.LONG);
		// } else if (error?.response?.status == 404) {
		//   Toast.show(error?.response?.data?.msg, Toast.LONG);
		// } else if (error?.response?.status == 429) {
		//   dispatch(sessionLogin(null));
		// } else if (error?.response?.status == 432) {
		//   dispatch(sessionLogin(null));
		// } else if (error?.response?.status == 401) {
		//   console.log('EXPIRE TOKEN', isRefreshing);
		//   Toast.show(error?.response?.data?.message, Toast.LONG);
		//  } else if (
		//   error?.response?.status == 421 ||
		//   error?.response?.status == 412
		// ) {
		//   Toast.show(error?.response?.data?.message, Toast.LONG);
		// } else if (error?.response?.status == 422) {
		//   for (const [key, value] of Object.entries(error?.response?.data?.error)) {
		//     Toast.show(value, Toast.SHORT);
		//   }
		// }
		return Promise.reject(error);
	},
);

export { Api };
